import { useState } from "react"
import { HexMap } from "../../Data/HexMap/HexMap"
import { HexMapBuilderParams, BuildHexMap } from "../../Data/HexMap/HexMapBuilder"
import { HexMapModifier } from "../../Data/HexMap/HexMapModifier"
import { All } from "../../Util/Constants/Quantities"
import { TransformTranslate } from "../../Util/Transform/Transform"
import { HxMapGroup } from "../HxMap/HxMapGroup"
import './KeyCompass.scss'
import { ClassNames } from "../../Util/ClassNames"

export function KeyCompass(props:{width?:number, height?:number, radius?:number}){
        const [intervalsOn, setIntervalsOn] = useState<boolean>(false)
        const width:number = (props.width) ? props.width : 500
        const height:number = (props.height) ? props.height : 500
        const radius:number = (props.radius) ? props.radius : 100
        const getMap = () => {
            const params:HexMapBuilderParams = {
                rows:3, columns:4, tonic:0, radius:radius
            }
            const map:HexMap = BuildHexMap(params)
            const mod:HexMapModifier = new HexMapModifier(map)
            mod.notes_setVisible([All], false)
            mod.keys_setOpen([All], false)
            map.keys[0][0].predefinedLabel = '7th'
            map.keys[0][1].predefinedLabel = 'b6th'
            map.keys[0][2].predefinedLabel = '4th'
            map.keys[0][3].predefinedLabel = '2nd'
            map.keys[1][0].predefinedLabel = 'b3rd'
            map.keys[1][1].predefinedLabel = ''
            map.keys[1][2].predefinedLabel = '6th'
            map.keys[1][3].predefinedLabel = 'b5th'
            map.keys[2][0].predefinedLabel = 'b7th'
            map.keys[2][1].predefinedLabel = '5th'
            map.keys[2][2].predefinedLabel = '3rd'
            map.keys[2][3].predefinedLabel = 'b2nd'

            if(intervalsOn){
                map.keys[0][0].predefinedLabel = '1'
                map.keys[0][1].predefinedLabel = '8'
                map.keys[0][2].predefinedLabel = '5'
                map.keys[0][3].predefinedLabel = '2'
                map.keys[1][0].predefinedLabel = '3'
                map.keys[1][2].predefinedLabel = '9'
                map.keys[1][3].predefinedLabel = '6'
                map.keys[2][2].predefinedLabel = '4'
                map.keys[2][0].predefinedLabel = '10'
                map.keys[2][1].predefinedLabel = '7'
                map.keys[2][3].predefinedLabel = '1'

                map.keys[0][0].secondaryLabel = '-11'
                map.keys[0][1].secondaryLabel = '-4'
                map.keys[0][2].secondaryLabel = '-7'
                map.keys[0][3].secondaryLabel = '-10'
                map.keys[1][0].secondaryLabel = '-9'
                map.keys[1][2].secondaryLabel = '-3'
                map.keys[1][3].secondaryLabel = '-6'
                map.keys[2][2].secondaryLabel = '-8'
                map.keys[2][0].secondaryLabel = '-2'
                map.keys[2][1].secondaryLabel = '-5'
                map.keys[2][3].secondaryLabel = '-11'
            }

            mod.keys_setSelected([1,2,4,6,9,10])
            mod.keys_setHilited([5])
            return map
        }
        const getButtonLabel = () => {
            return ((intervalsOn) ? 'hide' : 'show') + ' intervals'
        }
        const onIntervalToggle = () => {
            setIntervalsOn(!intervalsOn)
        }
        const getClassNames = () => {
            const classNames:ClassNames = new ClassNames(['key-compass'])
            if(intervalsOn){
                classNames.addClass('intervals-on')
            }
            return classNames.toString()
        }
        return(
            <div className={getClassNames()}>
                <svg width={width} height={height} className={'hex-parent'}>
                    <g transform={TransformTranslate((width/2) - (radius * .4),height/2)}>
                        <HxMapGroup hexMap={getMap()} onKeyClick={()=>{}} onNoteClick={()=>{}}>
                        </HxMapGroup>
                    </g>
                </svg>
                <div style={{marginTop:0}}><button type='button' onClick={onIntervalToggle}>{getButtonLabel()}</button></div>
            </div>
        )
    
}